angular.module('unergie.main')
.controller('modifOtPsModalCtrl', ($scope, $sce, $filter, $uibModalInstance, $q, ApiUser, CommonRegex, DataAccess, Tokens, consumptionAnalysis, Tariff, TogglerUtils, PrmValuesValidatorService,
    contract, ReferencesService, BoFeaturesService, PrmUtilsService, AlertManager, AdminComments, MetaWatcher, ErrorCatcher, AuthService, ContractConstants) => {
    $scope.contract = contract
    $scope.activationTelesellerMode = BoFeaturesService.isFeatureOn('activationTelesellerMode')
    $scope.canManualActivation = BoFeaturesService.isFeatureOn('canManualActivation')
    $scope.modifRoutingTariff = BoFeaturesService.isFeatureOn('modifRoutingTariff')
    $scope.modifDatePopoverClass = ''

    $scope.consumptionAnalysis = consumptionAnalysis

    $scope.proMode = contract.account && contract.account.category === 'pro'
    $scope.smallBusinessMode = contract.account && contract.account.category === 'small-business'
    $scope.displayWarningOverdue = ![null, undefined, 'CANCELLED'].includes(contract.suspension_status)

    const hotlineNumber = BoFeaturesService.get('hotlineNumber')
    $scope.showTools = !BoFeaturesService.get('isEnvProd')

    $scope.canFlagActivationInJira = BoFeaturesService.isFeatureOn('canFlagActivationInJira')
    $scope.canSeeActivationMessages = BoFeaturesService.isFeatureOn('canSeeActivationMessages')
    $scope.prices = {}

    $scope.nameRegex = CommonRegex.fullname
    $scope.phoneRegex = CommonRegex.phone.french

    $scope.isLinkyN2 = () => PrmUtilsService.isLinkyN2($scope.contract.prm)
    $scope.maxDays = PrmUtilsService.getMaxDaysForPRMIntervention($scope.contract.prm)

    $scope.urgenceText = undefined

    $scope.urgences = ContractConstants.urgencesOtPsList

    $scope.slots = ContractConstants.slotList

    $scope.availableDesiredHour = ['08', '09', '10', '11', '13', '14', '15', '16']

    $scope.availableDesiredMinute = ['00', '15', '30', '45']

    $scope.selectedHourAndMinute = {
        selectedDesiredHour: $scope.availableDesiredHour[0],
        selectedDesiredMinute: $scope.availableDesiredMinute[0],
    }

    $scope.availableSlots = undefined

    $scope.isC5 = !['C2', 'C3', 'C4', 'INDET_C2_C3'].includes($scope.contract.prm.segment)

    $scope.close = $uibModalInstance.dismiss

    $scope.modificationErrorCode = null
    $scope.modificationErrorNotified = false

    $scope.showFTARelatedMessages = () => {
        return $scope.modificationValues && $scope.modificationValues.choosen_routing_tariff && _.get($scope.modificationValues, 'choosen_routing_tariff.hidden') !== true
    }

    const minDate = moment().add(1, 'day').startOf('day')
    const maxDate = moment().add($scope.maxDays, 'day').startOf('day')

    let desired_date = moment()
    if (desired_date.isBefore(minDate)) {
        desired_date = moment(minDate)
    }

    if (desired_date.isAfter(maxDate)) {
        desired_date = moment(maxDate)
    }

    $scope.minDate = minDate.toDate()
    $scope.maxDate = maxDate.toDate()

    $scope.tariffs = {}

    $scope.getModificationDate = () => {
        const last_routing_tariff_modif_date = $scope.contract.prm.last_routing_tariff_modif_date && moment($scope.contract.prm.last_routing_tariff_modif_date)
        let lrtmdClass = ''
        const last_calendar_modif_date = $scope.contract.prm.last_calendar_modif_date && moment($scope.contract.prm.last_calendar_modif_date)
        let lcmdClass = ''
        const last_power_increase_date = $scope.contract.prm.last_power_increase_date && moment($scope.contract.prm.last_power_increase_date)
        let lpidClass = ''
        const last_power_decrease_date = $scope.contract.prm.last_power_decrease_date && moment($scope.contract.prm.last_power_decrease_date)
        let lpddClass = ''
        const service_level_modification_ts = $scope.contract.prm.service_level_modification_ts && moment($scope.contract.prm.service_level_modification_ts)
        let slmClass = ''
        let armisticeClass = ''
        if (last_routing_tariff_modif_date && last_routing_tariff_modif_date.isAfter(moment().add(-1, 'year'))) {
            $scope.modifDatePopoverClass = 'red'
            $scope.ftaModifInYear = true
            lrtmdClass = 'red'
        }
        if (last_calendar_modif_date && last_calendar_modif_date.isAfter(moment().add(-1, 'year'))) {
            $scope.modifDatePopoverClass = $scope.modifDatePopoverClass || 'orange'
            $scope.calendarModifInYear = true
            lcmdClass = 'red'
        }
        if (last_power_increase_date && last_power_increase_date.isAfter(moment().add(-1, 'year'))) {
            $scope.modifDatePopoverClass = $scope.modifDatePopoverClass || 'orange'
            $scope.powerIncreaseModifInYear = true
            lpidClass = 'red'
        }
        if (last_power_decrease_date && last_power_decrease_date.isAfter(moment().add(-1, 'year'))) {
            $scope.modifDatePopoverClass = $scope.modifDatePopoverClass || 'orange'
            $scope.powerDecreaseModifInYear = true
            lpddClass = 'red'
        }
        // on peut changer la FTA dans les 6 mois après l'ouverture aux service niv.2
        if ($scope.contract.prm.service_level === 2 && service_level_modification_ts && service_level_modification_ts.isAfter(moment().add(-6, 'month'))) {
            $scope.modifDatePopoverClass = ''
            $scope.serviceLevelModificationPastSixMonth = true
            slmClass = 'green'
        }
        // on peut changer la FTA 2 mois après un CDF dans DISCO
        if ($scope.contract.distributor_it === 'DISCO' && moment($scope.contract.commissioning_date).isAfter(moment().add(-2, 'month')) && $scope.contract.subscription_type === 'CDF') {
            $scope.modifDatePopoverClass = ''
            $scope.discoCDFTwoMonth = true
            armisticeClass = 'green'
        }
        $scope.modificationDatePopoverText = `<b>Dates de dernières modifications</b> :<br>` +
        `<ul><li><b>Formule Tarifaire Acheminement</b> : <span class="${lrtmdClass}">${last_routing_tariff_modif_date ? last_routing_tariff_modif_date.format('DD/MM/YYYY') : 'N/C'}</span></li>` +
        `<li><b>Calendrier fournisseur</b> : <span class="${lcmdClass}">${last_calendar_modif_date ? last_calendar_modif_date.format('DD/MM/YYYY') : 'N/C'}</span></li>` +
        `<li><b>Puissance (à la hausse)</b> : <span class="${lpidClass}">${last_power_increase_date ? last_power_increase_date.format('DD/MM/YYYY') : 'N/C'}</span></li>` +
        `<li><b>Puissance (à la baisse)</b> : <span class="${lpddClass}">${last_power_decrease_date ? last_power_decrease_date.format('DD/MM/YYYY') : 'N/C'}</span></li>` +
        `</ul>` +
        `<b>Linky n2 communicant</b> : ${$scope.isLinkyN2() ? 'Oui' : 'Non'}<br>` +
        `<b>Ouverture aux service niv. 2</b> : <span class="${slmClass}">${service_level_modification_ts ? service_level_modification_ts.format('DD/MM/YYYY') : 'N/C'}</span><br>` +
        `<b>Armistice CDF + DISCO</b> : <span class="${armisticeClass}">${$scope.discoCDFTwoMonth ? 'Oui' : 'Non'}</span>`
    }

    $scope.getModificationDate()

    $scope.chosen = {
        overrideContact: false,
        choosen_id_p_calendar: contract.prm.id_p_calendar,
        choosen_max_power: contract.prm.max_power,
        choosen_temp_class_powers: contract.choosen_temp_class_powers || contract.prm.temp_class_powers,
        choosen_express: false,
        choosen_routing_tariff: contract.prm.routing_tariff,
        choosen_long_usage_context: contract.prm.long_usage_context,
        choosen_long_usage_package: contract.prm.long_usage_package,
        chosen_phase: PrmUtilsService.getPhasingForNbWires(contract.prm && contract.prm.nb_wires),
        slot: $scope.slots[0].id,
        date: desired_date.toDate(),
        desired_date: desired_date.toDate(),
        enedisSlot: undefined,
        contact: {
            civ: 'M.',
            sn: '',
            givenname: '',
            phone: '',
        },
    }

    $scope.validateModificationValues = () => {
        const payload = _.assign({}, contract, $scope.chosen)
        return PrmValuesValidatorService.validate(payload, !!$scope.proMode, true).then((result) => {
            $scope.modificationValues = _.pickBy(result.toJSON(), (elem) => !elem.hidden || (elem.value && elem.enedisValue !== elem.value && elem.possibleValues && elem.possibleValues.length > 1))
            $scope.appendVoidFlexBox = Object.keys($scope.modificationValues).length % 3 === 2
            _.assign($scope.chosen, ..._.map(result.toJSON(), (values, field) => ({ [field]: values.value })))
            _.assign($scope.choosenValidity, ..._.map(result.toJSON(), (values, field) => ({ [field]: Boolean(values.hidden || (!values.isInvalid && values.value !== null)) })))
        })
        .catch(ErrorCatcher)
    }

    $scope.getContractTariff = () => {
        if (!$scope.proMode && TogglerUtils.isPlum()) {
            if (!$scope.tariffs[`${$scope.chosen.choosen_id_p_calendar}${$scope.chosen.choosen_max_power}`]) {
                const query = { idContract: contract.id, choosen_id_p_calendar: $scope.chosen.choosen_id_p_calendar, choosen_max_power: $scope.chosen.choosen_max_power }
                $scope.fetchingContractTariff = true
                return Tariff.getTariffForContract(query).$promise.then((tariff) => {
                    $scope.tariffs[`${$scope.chosen.choosen_id_p_calendar}${$scope.chosen.choosen_max_power}`] = tariff
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.fetchingContractTariff = false
                })
            }
        }
    }

    $scope.differentCalendar = () => $scope.chosen.choosen_id_p_calendar !== contract.prm.id_p_calendar

    $scope.differentPower = () => $scope.chosen.choosen_max_power !== contract.prm.max_power

    $scope.differentRoutingTariff = () => $scope.chosen.choosen_routing_tariff !== contract.prm.routing_tariff

    $scope.differentContext = () => $scope.chosen.choosen_long_usage_context !== (contract.prm && contract.prm.long_usage_context)

    $scope.differentPackage = () => $scope.chosen.choosen_long_usage_package !== (contract.prm && contract.prm.long_usage_package)

    $scope.differentPhasing = () => $scope.chosen.chosen_phase !== PrmUtilsService.getPhasingForNbWires(contract.prm && contract.prm.nb_wires)

    $scope.choosenValidity = {}

    $scope.warningLU = () => {
        return ($scope.chosen.choosen_routing_tariff === 'BTINFLU' && $scope.chosen.choosen_long_usage_context === null) ||
            (['SSCPT', 'PSC'].includes(contract.prm.metter_kind) && $scope.chosen.choosen_long_usage_package === null && $scope.chosen.subscription_type !== 'FIRST_MES')
    }
    $scope.canModify = () => {
        if ($scope.isC5) {
            return $scope.tariff && !$scope.computing && !$scope.resultOk &&
                ($scope.chosen.choosen_id_p_calendar && $scope.chosen.choosen_max_power && $scope.chosen.choosen_routing_tariff) &&
                ($scope.differentCalendar() || $scope.differentPower() || $scope.differentContext() || $scope.differentPackage() || $scope.differentRoutingTariff()) &&
                ($scope.chosen.choosen_routing_tariff !== 'BTINFLU' || !!$scope.chosen.choosen_long_usage_context)
        }
        return Object.values($scope.choosenValidity).every((validity) => validity)
    }
    $scope.canNotifyError = () => !!$scope.modificationErrorCode

    $scope.format = (stringDate) => moment(stringDate, 'YYYY-MM-DD').format('DD/MM/YYYY')

    $scope.longFormat = (stringDate) => moment(stringDate, 'YYYY-MM-DD').format('DD MMMM YYYY')

    $scope.differentMonthes = (date1, date2) => moment(date1, 'YYYY-MM-DD').month() !== moment(date2, 'YYYY-MM-DD').month()

    $scope.isObjectField = (field, conf) => Boolean(typeof $scope.chosen[field] === 'object' && conf.possibleRange)

    if (!$scope.contract.prm) {
        AlertManager.error('Le contrat ne possède pas de PRM !')
    }

    $scope.needInter = function () {
        const toReturn = $scope.tariff && (!$scope.tariff.remote || ($scope.tariff.option && $scope.tariff.option.remote === false))
        if (!toReturn) {
            $scope.chosen.choosen_express = false
        }
        return toReturn || false
    }

    $scope.displayDateMessage = () => $scope.canSeeActivationMessages

    $scope.displayActivationLinkyMessage = () => $scope.isLinkyN2() && $scope.canSeeActivationMessages

    const postComment = () => AdminComments.addComment({ object: contract.id, comment: $scope.message }).$promise.catch(ErrorCatcher)

    $scope.fetchPrices = () => {
        $scope.computeTariff()
        $scope.getContractTariff()
    }

    $scope.lessThanOneYear = (date) => {
        return moment(date).isAfter(moment().add(-1, 'year'))
    }

    // COMPUTE TARIF
    $scope.computeTariff = function (type) {
        $scope.computing = true
        $scope.needInter()
        $scope.urgenceText = _.find($scope.urgences, { value: $scope.chosen.choosen_express }).text
        const payload = {
            id_contract: $scope.contract.id,
            choosen_mes_type: $scope.chosen.choosen_express ? 'EXPRESS' : 'NORMAL',
            choosen_max_power: $scope.chosen.choosen_max_power,
            choosen_id_p_calendar: $scope.chosen.choosen_id_p_calendar,
            choosen_routing_tariff: $scope.chosen.choosen_routing_tariff,
            chosen_phase: $scope.chosen.chosen_phase,
        }
        return ApiUser.computeTariff({ pro: ($scope.proMode || $scope.smallBusinessMode) }, payload).$promise.then((tariffResult) => {
            $scope.tariff = tariffResult.toJSON()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.computing = false
        })
    }

    $scope.valueChanged = () => {
        $scope.validateModificationValues().then(() => {
            if ($scope.isC5) { /* désactiver pour le c2c4 */
                if ($scope.chosen.choosen_id_p_calendar && $scope.chosen.choosen_max_power && $scope.chosen.choosen_routing_tariff) {
                    $scope.fetchPrices()
                }
            }
        })
    }

    $scope.valueChanged()


    $scope.translateValueLabel = (values, value) => {
        const found = _.find(values, { value })
        return found ? found.label : value
    }

    $scope.getItemMessage = (values, value) => {
        const found = _.find(values, { value })
        return found ? found.message : null
    }

    const parseAvailableSlots = function (result) {
        $scope.days = []
        _.forEach(result, (r) => {
            const existing = _.find($scope.days, { date: r.date })
            if (existing) {
                existing.availableSlots.push(r.code)
            } else {
                $scope.days.push({ date: r.date, availableSlots: [r.code] })
            }
        })
    }


    const preparePayload = function () {
        const choosenSlot = _.pick($scope.chosen, [
            'choosen_id_p_calendar',
            'choosen_max_power',
            'choosen_temp_class_powers',
            'choosen_express',
            'choosen_long_usage_context',
            'choosen_long_usage_package',
            'choosen_routing_tariff',
            'chosen_phase',
        ])

        if ($scope.chosen.overrideContact) {
            choosenSlot.contact = $scope.chosen.contact
        }

        choosenSlot.desired_date = moment($scope.chosen.desired_date).format('YYYY-MM-DD')

        if ($scope.chosen.enedisSlot && ($scope.chosen.enedisSlot.slot !== 'RETRY')) {
            $scope.chosen.slot = $scope.chosen.enedisSlot.slot
            $scope.chosen.date = moment($scope.chosen.enedisSlot.date, 'YYYY-MM-DD').toDate()
        }
        if ($scope.needInter() || $scope.availableSlots) {
            choosenSlot.slot = $scope.chosen.slot
            choosenSlot.date = moment($scope.chosen.date).format('YYYY-MM-DD')
        }
        choosenSlot.intervention_comment = $scope.chosen.intervention_comment

        if (!$scope.isC5) {
            choosenSlot.choosen_id_p_calendar = undefined
        }
        return choosenSlot
    }

    const computeResultMessage = function (intervention, choosenSlot) {
        const params = {
            old: {
                id_p_calendar: contract.id_p_calendar,
                max_power: contract.max_power,
            },
            new: {
                id_p_calendar: $scope.chosen.choosen_id_p_calendar,
                max_power: $scope.chosen.choosen_max_power,
            },
        }
        let modifiedFields = ''
        let header = ''
        if (params.old.id_p_calendar !== params.new.id_p_calendar) {
            header += `<b>d'option tarifaire</b>`
            modifiedFields += `<br>Option tarifaire : <b>${params.old.id_p_calendar}</b> => <b>${params.new.id_p_calendar}</b>`
        }
        if (params.old.max_power !== params.new.max_power) {
            header += params.old.id_p_calendar !== params.new.id_p_calendar ? ' et <b>de puissance</b>' : '<b>de puissance</b>'
            modifiedFields += `<br>Puissance : <b>${params.old.max_power}</b> => <b>${params.new.max_power}</b>`
        }
        if ($scope.differentRoutingTariff()) {
            modifiedFields += `<br>Formule tarifaire d'acheminement : <b>${contract.prm.routing_tariff || contract.routing_tariff}</b> => <b>${$scope.chosen.choosen_routing_tariff}</b>`
        }
        let message = `Demande de modification ${header} effectuée par <b>${AuthService.getAuth().user}</b>, envoyée avec succès`
        message += modifiedFields
        if (intervention) {
            if (intervention.remote) {
                message += `<br>L'intervention sera effectuée sans déplacement`
            } else {
                message += '<br>Un technicien se présentera chez le client (présence du client obligatoire)'
            }
            message += ` le <b>${moment(intervention.date, 'YYYY-MM-DDZ').format('DD/MM/YYYY')}`
            if (intervention.begin) {
                message += ` entre ${intervention.begin}`
                message += ` et ${intervention.end}</b>`
            }
        }
        if (!intervention && choosenSlot.slot) {
            if (!choosenSlot.choosen_express) {
                message += `<br><b>Attention</b> Le RDV choisi n'a pas été confirmé par Enedis. `
                message += `Enedis va donc prendre contact avec le client d'ici 10 jours ouvrés au soir pour programmer un autre rendez-vous.`
            } else {
                message += `<br><b>Attention</b> Le RDV choisi n'a pas été confirmé par Enedis.`
                message += `<br>Pour que la mise en service puisse avoir lieu d'ici 5 jours ouvrés un traitement immédiat par le service client Plüm énergie est nécessaire :`
                message += '<ul><li>tenter un transfert accompagné vers le service client Plüm</li>'
                message += `<li>en cas d'injoignabilité donner le numéro au client (${hotlineNumber}) et lui dire d'appeler au plus vite</li></ul>`
            }
            message += '<br><b>NB :</b> pour bien préciser la date butoir au client, '
            message += `compter 5 jours pleins à partir de demain, sans compter les samedis, dimanches et jours fériés.<br>`
        }
        if ($scope.tariff) {
            message += `<br>Prestation facturée : ${$scope.tariff.total} €`
            if ($scope.tariff.option) {
                message += `<br>Prestation prévue : ${$scope.tariff.option.label}`
            }
        }
        if (choosenSlot.contact) {
            message += `<br>Contact : ${choosenSlot.contact.civ} `
            message += `${choosenSlot.contact.givenname} `
            message += choosenSlot.contact.sn
            message += `, tel : ${choosenSlot.contact.phone}`
        }
        if (choosenSlot.intervention_comment) {
            message += `<br>Commentaire pour l'intervention : ${choosenSlot.intervention_comment} `
        }
        return message
    }

    $scope.modify = function () {
        if ($scope.modifying === true) {
            return
        }
        $scope.modifying = true
        const choosenSlot = preparePayload()
        return ApiUser.amendContract({ id_contract: contract.id }, choosenSlot).$promise
        .then((result) => {
            if (result.success) {
                $scope.availableSlots = undefined
                $scope.resultOk = true
                $scope.message = computeResultMessage(result.intervention, choosenSlot)
                $scope.messageHtml = $sce.trustAsHtml($scope.message)
                AlertManager.success('Demande de modification envoyée avec succès !')
                postComment()
            } else if (result.intervention_needed && result.timeTable) {
                $scope.availableSlots = result.timeTable
                $scope.chosen.enedisSlot = {
                    slot: $scope.availableSlots[0].code,
                    date: $scope.availableSlots[0].date,
                }
                parseAvailableSlots($scope.availableSlots)
            } else {
                AlertManager.error('Message de retour mal formé')
            }
        })
        .catch((error) => {
            const msg = (error && error.data && error.data.message) || 'Erreur inconnue'
            AlertManager.error(msg, 15000)
            $scope.modificationErrorCode = (error && error.data && error.data.sgeCode) || undefined
        })
        .finally(() => {
            $scope.modifying = false
        })
    }

    $scope.notifyError = function () {
        $scope.notifying = true
        return ApiUser.notifyActivationError({ idAccount: contract.id_account, idContract: contract.id }, { error_code: $scope.modificationErrorCode }).$promise
        .then((result) => {
            $scope.modificationErrorNotified = true
            return AlertManager.success('Le client a été notifié de l\'erreur')
        })
        .catch((error) => {
            const msg = (error && error.data && error.data.message) || 'Erreur inconnue'
            return AlertManager.error(msg, 15000)
        })
        .finally(() => {
            $scope.notifying = false
        })
    }

    $scope.isWarningFreeLinkyDisplayed = () => {
        return !PrmUtilsService.isLinky($scope.contract.prm.metter_kind) && $scope.differentCalendar() && ($scope.tariff && !$scope.tariff.remote) && $scope.tariff.total > 0
    }

    $scope.showFutureOffPeak = () => {
        return $scope.modificationValues && $scope.modificationValues.choosen_id_p_calendar.enedisValue === 'BASE' && $scope.modificationValues.choosen_id_p_calendar.value === 'HPHC' &&
            (['BTINFMUDT', 'BTINFCU4', 'BTINFMU4'].includes($scope.contract.routing_tariff) ? $scope.contract.off_peak_label : _.get($scope.contract.prm, 'future_off_peak_labels.BTINFMUDT.HC'))
    }

    // RETURN OK
    $scope.ok = function () {
        $uibModalInstance.close($scope.message)
    }
    $uibModalInstance.dismiss = $scope.ok
})
